(function(){
 var $=function(i){return document.getElementById(i)};
 function eur(n){return '€'+Number(n).toFixed(2).replace('.',',')}
 if($('ci')){
  var calc=function(){var i=+$('ci').value||0,s=+$('cs').value||0,n=+$('cn').value||0,w=s-i;
   $('o1').textContent=eur(w);$('o2').textContent=eur(w*n);$('o3').textContent=(s>0?Math.round(w/s*100):0)+'%'};
  ['ci','cs','cn'].forEach(function(i){$(i).addEventListener('input',calc)});calc();
 }
 Array.prototype.forEach.call(document.querySelectorAll('[data-code]'),function(b){
  b.addEventListener('click',function(){var t=b.textContent;
   try{navigator.clipboard.writeText(b.getAttribute('data-code')).then(function(){b.textContent='Gekopieerd ✓';setTimeout(function(){b.textContent=t},1800)})}catch(e){}});
 });
 var pop=$('pop');
 if(pop){
  var seen=function(){try{return sessionStorage.getItem('rf_pop')}catch(e){return null}};
  var show=function(){if(seen())return;pop.classList.add('on');try{sessionStorage.setItem('rf_pop','1')}catch(e){}};
  var hide=function(){pop.classList.remove('on')};
  setTimeout(show,8000);
  document.addEventListener('mouseout',function(e){if(!e.relatedTarget&&e.clientY<5)show()});
  ['px','pn'].forEach(function(i){$(i).addEventListener('click',hide)});
  pop.addEventListener('click',function(e){if(e.target===pop)hide()});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')hide()});
 }
})();
